<template>
  <section>
    <h4 class="form-card-header">{{ $t('registration.customer-type-info') }}</h4>
    <div>
<!--      <label class="custom-form-label" for="pi_customer_type">{{ $t('registration.customer-type') }}</label>-->
      <b-form-group id="pi_customer_type" class="customer-type-container">
        <b-form-radio v-for="type in customerTypes"
                      :key="type.id"
                      name="individual"
                      v-model="v$.form.customerType.$model"
                      v-bind="v$.form.customerType.$touch()"
                      :value="type.value"
                      :style="form.customerType === type.value ? 'border: 1px solid rgb(var(--rgb-primary-color)); background-color: rgba(var(--rgb-primary-color), .1)' : 'border: 1px solid var(--tab-border-color);'"
                      class="customer-type-item ">
<!--          <i class='sr sr-sun customer-type-icon'></i>-->
          <svg class="customer-type-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" v-html="type.svg"></svg>
          <p class="custom-form-radio-label">{{ type.label }}</p>
        </b-form-radio>
      </b-form-group>

      <div class="text-center" v-show="form.customerType === 'child'"><em class="text-danger">Санамж: Та хүүхдийн үнэт цаасны данс нээж буй тохиолдолд эхлээд ХУВЬ ХҮН товч дээр дарж, өөрийн дансаа үүсгэсний дараа ХҮҮХЭД товч дээр дарж хүүхдийнхээ дансыг нээхийг анхаарна уу.</em></div>

      <section class="sub-step-buttons-container">
        <ic-button v-if="form.customerType === 'child'" size="tn" type="button" variant="success"  @click="next()" class="d-flex align-items-center ml-3">{{ $t('button.next') }} <i class="sr sr-chevron-right"></i></ic-button>
      </section>
      <ic-dialog :show="form.customerType === 'individual'">
        <div class="dialog-box e-mongolia-dialog">
          <div class="col align-items-center justify-content-center text-center p-3">
            <img src="/img/emongolia.jpg" alt="Бүртгэлийн мэдээллээ e-mongolia-с татах" width="240" class="rounded" />
            <p class='pt-3' style='font-size: 0.9rem; line-height: 1.5rem;'>Та E-Mongolia ашиглан мэдээллээ баталгаажуулахыг зөвшөөрч байна уу?</p>
          </div>
          <div class="d-flex justify-content-center">
            <section class="sub-step-buttons-container">
              <ic-button size="tn" type="button" color="grey" @click="clearType" class="d-flex align-items-center mr-3">
                <i class="sr sr-chevron-left"></i>{{ $t('emongolia.refuse') }}
              </ic-button>
              <ic-button size="tn" type="button" variant="success" @click="redirectToDan" class="d-flex align-items-center ml-3">
                {{ $t('emongolia.agree') }} <i class="sr sr-chevron-right"></i>
              </ic-button>
            </section>
          </div>
        </div>
      </ic-dialog>
    </div>
  </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import danApi from '../../api/danApi'
import MakeOrder from '../OrderForm/MakeOrder.vue'

export default {
  components: { MakeOrder },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      customerTypes: [
        { id: 1,
          value: 'individual',
          label: `${ this.$t('customer.type.individual') }`,
          svg: '<path d="M208 48C208 74.51 186.5 96 160 96C133.5 96 112 74.51 112 48C112 21.49 133.5 0 160 0C186.5 0 208 21.49 208 48zM152 352V480C152 497.7 137.7 512 120 512C102.3 512 88 497.7 88 480V256.9L59.43 304.5C50.33 319.6 30.67 324.5 15.52 315.4C.3696 306.3-4.531 286.7 4.573 271.5L62.85 174.6C80.2 145.7 111.4 128 145.1 128H174.9C208.6 128 239.8 145.7 257.2 174.6L315.4 271.5C324.5 286.7 319.6 306.3 304.5 315.4C289.3 324.5 269.7 319.6 260.6 304.5L232 256.9V480C232 497.7 217.7 512 200 512C182.3 512 168 497.7 168 480V352L152 352z"/>'
        },
        { id: 2,
          value: 'child',
          label: `${ this.$t('customer.type.child') }`,
          svg: '<path d="M256 64C256 99.35 227.3 128 192 128C156.7 128 128 99.35 128 64C128 28.65 156.7 0 192 0C227.3 0 256 28.65 256 64zM155.7 170.2C167.3 173.1 179.6 176 192.2 176C232.1 176 269.3 155.8 291 122.4L309.2 94.54C318.8 79.73 338.6 75.54 353.5 85.18C368.3 94.82 372.5 114.6 362.8 129.5L344.7 157.3C326.4 185.4 301.2 207.3 272 221.6V480C272 497.7 257.7 512 240 512C222.3 512 208 497.7 208 480V384H176V480C176 497.7 161.7 512 144 512C126.3 512 112 497.7 112 480V221.4C83.63 207.4 58.94 186.1 40.87 158.1L21.37 129.8C11.57 115 15.54 95.18 30.25 85.37C44.95 75.57 64.82 79.54 74.62 94.25L94.12 123.5C108.5 145 129.2 160.9 152.9 169.3C153.9 169.5 154.8 169.8 155.7 170.2V170.2z"/>'
        },
        // { id: 3,
        //   value: 'company',
        //   label: `${ this.$t('customer.type.organization') }`,
        //   svg: '<path d="M336 0C362.5 0 384 21.49 384 48V464C384 490.5 362.5 512 336 512H240V432C240 405.5 218.5 384 192 384C165.5 384 144 405.5 144 432V512H48C21.49 512 0 490.5 0 464V48C0 21.49 21.49 0 48 0H336zM64 272C64 280.8 71.16 288 80 288H112C120.8 288 128 280.8 128 272V240C128 231.2 120.8 224 112 224H80C71.16 224 64 231.2 64 240V272zM176 224C167.2 224 160 231.2 160 240V272C160 280.8 167.2 288 176 288H208C216.8 288 224 280.8 224 272V240C224 231.2 216.8 224 208 224H176zM256 272C256 280.8 263.2 288 272 288H304C312.8 288 320 280.8 320 272V240C320 231.2 312.8 224 304 224H272C263.2 224 256 231.2 256 240V272zM80 96C71.16 96 64 103.2 64 112V144C64 152.8 71.16 160 80 160H112C120.8 160 128 152.8 128 144V112C128 103.2 120.8 96 112 96H80zM160 144C160 152.8 167.2 160 176 160H208C216.8 160 224 152.8 224 144V112C224 103.2 216.8 96 208 96H176C167.2 96 160 103.2 160 112V144zM272 96C263.2 96 256 103.2 256 112V144C256 152.8 263.2 160 272 160H304C312.8 160 320 152.8 320 144V112C320 103.2 312.8 96 304 96H272z"/>'
        // }
      ],
      form: {
        customerType: null,
      }
    }
  },
  validations() {
    return {
      form: {
        customerType: { required }
      }
    }
  },
  mounted() {
    // this.v$.form.customerType.$model = this.customerTypes[0].value
  },
  methods: {
    clearType() {
      this.form.customerType = null;
    },
    async redirectToDan() {
      this.form.customerType = null;
      const {data} = await danApi.getGrantUrl()

      window.location.href = data;
    },
    async next() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$emit('next', this.form)
      } else {
        alert(`${ this.$('helper.please-fill-required-fields') }`)
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  },
}
</script>

<style lang='scss' scoped>
.e-mongolia-dialog {

  button {
    padding: 0.4rem 1rem;
    border: 0;
    border-radius: 0.3rem;
    font-family: inherit;
    font-size: 0.9rem;
    transition: all 0.3s;
  }

  .agree-button {
    background-color: transparent;
    border: 2px solid rgb(var(--rgb-system-light-green));
    color: rgb(var(--rgb-system-light-green));

    &:hover {
      background-color: rgb(var(--rgb-system-light-green));
      border: 2px solid rgb(var(--rgb-system-light-green));
      color: rgb(var(--white));
    }
  }
  .refuse-button {
    background-color: var(--red);
    border: 2px solid rgb(var(--red-200));
    color: rgb(var(--red));
  }
}
.e-mongolia-description {
  font-size: 0.7rem !important;
}
.custom-form-label {
  color: var(--text-grey-color);
  font-size: var(--text-body-3-size);
  font-weight: var(--text-body-3-weight);
  line-height: var(--text-body-3-line-height);
}
.custom-form-radio-label {
  color: var(--text-primary-color);
  font-size: var(--text-body-3-size);
  font-weight: var(--text-body-3-weight);
  line-height: var(--text-body-3-line-height);
}
.customer-type {
  &-item {
    padding: 1rem 3rem;
    border-radius: 1rem;
    border: 1px solid var(--tab-border-color);
    transition: all .2s ease-in-out;
    float: none;
    margin: 0.5rem auto;
    width: 100%;
    &:hover {
      background-color: var(--white-or-dark-color);
      box-shadow: -1px 3px 10px -7px rgba(0, 0, 0, 0.4);
    }
  }
  &-icon {
    width: 5rem;
    height: 5rem;
    opacity: .3;
  }
}
@media (min-width: 768px) {
  .customer-type-item {
    //max-width: 15rem;
    float: left;
    margin-left: 2rem;
    width: calc(50% - 2rem);
  }
}
</style>